import { AspectRatio, Flex, Skeleton } from "@chakra-ui/react";

const BrandSkeleton = () => {
  return (
    <Flex direction="column" flex="1" gap="1">
      <AspectRatio ratio={2 / 1} w="full" rounded="xl" overflow="hidden">
        <Skeleton w="540px" h="260px" rounded="xl" />
      </AspectRatio>

      <Flex direction="column" gap="1">
        <Skeleton h="24px" w="180px" rounded="xl" />

        <Flex gap="2">
          <Skeleton h="24px" w="120px" rounded="xl" />
          <Skeleton h="24px" w="120px" rounded="xl" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BrandSkeleton;
